module.exports = __webpack_public_path__ + "img/80.b4b6d281.jpg";